import React from "react";

export const BankIdRegisterContext = React.createContext<any>(null);
